routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.routinesDetail', {
      url: "/consultas/detalle-rutinas/{id}",
      template: `<routines-detail sh-ctrl="shCtrl" id="id"></routines-detail>`,
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/routines-detail/routines-detail.config.js
 **/